import parse from "html-react-parser";
import { GetStaticPaths, GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ErrorPage404 from "../../components/404";
import Layout from "../../components/layout";
import AllResourcesTabV2 from "../../components/v2/all-resources-post";
import CallToActionSmall from "../../components/v2/call-to-action-sm";
import WhitepaperForm from "../../components/v2/form/whitepaper";
import { MwSmallIcon } from "../../components/v2/icons";
import {
  getAllResources,
  getAllWhitepaper,
  getWhitepaperForSlug
} from "../../lib/api";
import nextI18NextConfig from "../../next-i18next.config";
import "../../styles/scss/resources.module.scss";

const parentPage = "whitepaper"

export default function WhitepaperPosts({ pageData,allResources }) {
  const router = useRouter()
  let post =  pageData?.allWhitepaper?.edges?.[0]?.node

  if (!router.isFallback && !post?.slug) {
    return <ErrorPage404 />
  }

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const images = [
    post?.acf_resources?.sliderImages?.bookImage1,
    post?.acf_resources?.sliderImages?.bookImage2,
    post?.acf_resources?.sliderImages?.bookImage3
  ];

  return (
      <>
        <Layout isHomePage={post?.isFrontPage} pageTitle={post?.title}
                ogImage={post?.featuredImage?.node?.sourceUrl}
                uri={post?.uri}
                metaTitle={post?.seo?.title}
                metaDesc={post?.seo?.metaDesc}
                metaRobotsNoindex={post?.seo?.metaRobotsNoindex}
                metaRobotsNofollow={post?.seo?.metaRobotsNofollow}>
          <div className={'middle-wrapper site-page inner-resource'}>
            <section className={'inner-resource-section'}>
              <div className={'container'}>
                <div className={'d-flex'}>
                  <div className={'left-block'}>
                    <h1>{post?.title}</h1>
                    <div>{typeof post?.excerpt === "string" && parse(post?.excerpt)}</div>
                  </div>
                  <div className={'right-block contact-form'}>
                    <WhitepaperForm post={post}/>
                  </div>
                </div>
              </div>
            </section>

            <section className={'about-resource'}>
              <div className={'container'}>
                <div className={'section-tag testimonial'}><MwSmallIcon/> Middleware library</div>
                <h2>What is the whitepaper about?</h2>
                <div className={'d-flex'}>
                  <div className={'left-block slider-block'}>
                    <Carousel responsive={responsive} infinite={true}>
                      {images.map((image, index) => (
                          <div key={index}>
                            <div className="book-img-wrapper">
                              {image ? (
                                  <img src={image} className="img-slider" alt={`Middleware Whitepaper Image-${index}`} />
                              ) : (
                                  <p>Image not available</p>
                              )}
                            </div>
                          </div>
                      ))}
                    </Carousel>

                  </div>
                  <div className={'right-block'}>
                    <div className={'first-block'}>
                      <h3>{post?.acf_resources.aboutBook?.title1}</h3>
                      <p className={'sub-title'}>{post?.acf_resources.aboutBook?.subtitle}</p>
                      <h4>What to expect?</h4>
                      <ul className={"site-bullets"}>
                        {post != undefined && Object.keys(post?.acf_resources.aboutBook?.listPoint).map((keyName, i) => (
                            post?.acf_resources.aboutBook?.listPoint[keyName] != null && <li key={i}>
                              {post?.acf_resources.aboutBook?.listPoint[keyName]}
                            </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <AllResourcesTabV2 allResourcesData={allResources} selectedWhitepaper={post}/>

            <CallToActionSmall/>
          </div>
        </Layout>
      </>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const { params } = ctx;
  const data = await getWhitepaperForSlug(params?.slug as string, parentPage)
  const allResourcesData = await getAllResources()
  let post =  data?.allWhitepaper?.edges?.[0]?.node
  
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );

  return {
    props: {
      ...translations,
      pageData: data,
      allResources: allResourcesData,
      pageTitle: post?.seo?.title,
      description:post?.seo?.metaDesc,
      ogImage:post?.featuredImage?.node?.sourceUrl || null,
      uri:post?.uri,
      metaTitle:post?.seo?.title,
      metaDesc:post?.seo?.metaDesc,
      metaRobotsNoindex:post?.seo?.metaRobotsNoindex,
      metaRobotsNofollow:post?.seo?.metaRobotsNofollow,
    },
  }
}

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  const allPages = await getAllWhitepaper()
  const paths = allPages.edges.flatMap(({ node }) => {
    return (locales || nextI18NextConfig.i18n.locales).map((locale) => ({
      params: { slug: node?.slug },
      locale,
    }));
  }) || [];

  return {
    paths,
    fallback: false,
  }
}

